import { EntityLayout } from '@backstage/plugin-catalog';
import { UnclaimedOverviewContent } from './UnclaimedOverviewContent';
import { SecretsContextProvider } from '@backstage/plugin-scaffolder-react';

export const unclaimedEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <SecretsContextProvider>
        <UnclaimedOverviewContent />
      </SecretsContextProvider>
    </EntityLayout.Route>
  </EntityLayout>
);
